import { render, staticRenderFns } from "./EditRelationForm.vue?vue&type=template&id=65f64940"
import script from "./EditRelationForm.vue?vue&type=script&lang=js"
export * from "./EditRelationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports